<template>
  <div class="galeria-imagenes">
    <b-card header="Imágenes del Remito">
      <b-row v-if="seleccionImagenes">
        <b-col>
          <b-form>
            <b-form-group
              description="Imágenes (jpg, png o jpeg) o Documentos PDF de hasta 3MB">
              <b-form-file 
                v-model="files" 
                class="mt-3" 
                accept=".jpg, .png, .jpeg, .pdf" 
                placeholder="Seleccione una o más imágenes o documentos, o arrastrelos hasta aquí"
                multiple>
              </b-form-file>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="agregarImagenes">
                <b-input-group-text>
                  <i class="fa fa-remove"></i>
                </b-input-group-text>
              </b-input-group-append>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <template v-for="{ id, fileName, url, key } in imagenes">
          <b-col cols="12" md="4" :key="key">
            <b-card no-header class="galeria-imagen">
              <template v-if="isImagen(fileName)">
                <b-img fluid
                  @click="consultarImagen(url)"
                  :src="url"></b-img>
              </template>
              <template v-if="isPDF(fileName)">
                <div class="galeria-pdf">
                  <i class="fa fa-file-pdf-o fa-2x" @click="consultarPDF(url, fileName)"></i>
                  <label @click="consultarPDF(url, fileName)">{{ fileName }}</label>
                </div>
                <!-- <label>PDF</label> -->
              </template>  
              <div 
                  :class="{ 'footer': true, 'readonly': readonly }">
                <b-button 
                  v-if="!readonly"
                  size="sm" variant="danger" class="footer-button" 
                  @click.prevent="borrarImagen(id)">Borrar</b-button>
                <b-button size="sm" variant="primary" class="footer-button" 
                  @click.prevent="descargarImagen(url, fileName)">Descargar</b-button>
              </div>
            </b-card>
          </b-col>
        </template> 
      </b-row>

      <div v-if="!readonly" 
          class="add-table-btn">
        <div class="list-add-btn" @click.prevent="agregarImagenes">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>

      <div slot="footer">
        <!-- <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button> -->
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "remito/getField",
  mutationType: "remito/updateField",
});

export default {
  name: 'RemitosImagenes',
  components: {
    appImagen: Imagen,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    remitoId: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: [],
      uploaded: [],
      seleccionImagenes: false,
      selectedImageUrl: ''
    }
  },
  computed: {
    ...mapFields([
	    'imagenes',
    ]),
  },
  created() {
    let params = {
      remitoId: this.remitoId,
    }

    this.$store.dispatch('remito/getImagenes', params)
      .catch(err => this.showErrorMsj(err));
  },
  methods: {
    isImagen(fileName) {
      let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
      if (fileExtension == 'jpg' 
          || fileExtension == 'png'
          || fileExtension == 'jpeg') {
        return true;
      }
      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    borrarImagen (imagenId) {
      if (!this.readonly) {
        let params = {
          remitoId: this.remitoId,
          imagenId
        }
  
        this.showSpinner();
        this.$store.dispatch('remito/removeImagen', params)
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner())
      }
    },
    agregarImagenes() {
      if (!this.readonly) {
        this.seleccionImagenes = !this.seleccionImagenes;
      }
    },
    uploadFiles() {
      if (this.files) {
        if (this.files.length != 0) {
          this.uploaded = [];

          this.showSpinner();

          this.files.forEach(file => {
            let params = {
              remitoId: this.remitoId,
              file: file
            }

            this.uploaded.push(file);

            this.$store.dispatch('remito/addImagen', params)
              .then( () => this.fileUploaded(file))
              .catch( error => {
                this.hideSpinner();
                this.showErrorMsj (error);
              });
          });
        }
      }
    },
    fileUploaded(file) {
      console.log('Uploaded');

      let index = this.uploaded.findIndex(uploadedFile => uploadedFile.name == file.name);

      if (index != -1) {
        this.uploaded.splice(index, 1);

        if (this.uploaded.length == 0) {
          this.files = [];
          this.seleccionImagenes = false;
          this.hideSpinner();
        }
      }
    },
    close() {
      let params = {
        remitoId: this.remitoId,
        tieneImagenes: false
      }
      if (this.imagenes) {
        if (this.imagenes.length != 0) {
          params.tieneImagenes = true;
        }    
      }

      this.$emit('close', params);
    },
    descargarImagen(imageUrl, imagenName) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, imagenName);
        });
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(url, fileName) {
      window.open(url, '_blank');
    }
  },
  watch: {
    'files' : function(newVal, oldVal) {
      this.uploadFiles();
    },    
  }    
}
</script>
